import { paginationCalculator } from 'pagination-calculator';
export const createHeaders = () => {
  return [
    {
      name: '#',
      field: 'serialNo',
      type: 'text',
      headerTooltip: 'Line Item Number',
      width: 40,
      minWidth: 20,
      hide: false
    },
    // {
    //   name: 'Matching Candidate',
    //   field: 'matching',
    //   type: 'icon',
    //   headerTooltip: 'Matching Candidate',
    //   // width: 110,
    //   width: 40,
    //   minWidth: 40,
    //   hide: false,
    //   icon: 'icon-align fa fa-link green-color-icon'
    // },
    {
      name: 'Shift',
      field: 'shift',
      type: 'text',
      filter: false,
      width: 50,
      minWidth: 45,
      hide: false,
    },
    {
      name: 'Claimed',
      field: 'isClaimed',
      type: 'text',
      headerTooltip: 'Claimed',
      width: 50,
      minWidth: 40,
      maxWidth: 150,
      hide: false,
      icon: 'icon-align fa fa-anchor green-color-icon'
      // Claimed
    },
    {
      name: 'Unclaim',
      field: 'isUnClaimed',
      type: 'multi',
      headerTooltip: 'UnClaim',
      width: 35,
      minWidth: 40,
      maxWidth: 150,
      hide: false,
      icon: 'icon-align fa fa-remove orange-icon'
      // Claimed
    },
    {
      name: 'GPS',
      field: 'gpsTrackingStatus',
      type: 'icon',
      filter: false,
      width: 35,
      minWidth: 35,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'GPS',
      icon: 'icon-align fa fa-map-marker green-icon'
    },
    {
      name: 'Checked In',
      field: 'isCheckedIn',
      type: 'icon',
      filter: false,
      sort: false,
      headerTooltip: 'Checked In',
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-in green-icon'
    },
    {
      name: 'Break Time',
      field: 'breakTimeFlash',
      type: 'text',
      filter: false,
      width: 35,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'Break Time',
      icon: 'icon-align fa fa-pause-circle-o green-icon'
    },
    {
      name: 'Checked Out',
      field: 'isCheckedOut',
      type: 'icon',
      filter: false,
      sort: false,
      headerTooltip: 'Checked Out',
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-out fa-flip-horizontal green-icon'
    },
    // {
    //   name: 'Departments',
    //   type: 'multi',
    //   filter: false,
    //   width: 45,
    //   minWidth: 35,
    //   maxWidth: 150,
    //   hide: false,
    //   icon: 'icon-align fa fa-building',
    //   headerTooltip: 'Departments'
    // },
    {
      name: 'Name',
      field: 'name',
      type: 'text',
      filter: false,
      sort: true,
      width: 70,
      minWidth: 100,
      maxWidth: 150,
      hide: false,
    },
    // Call
    {
      name: 'Call',
      field: 'cellPhoneNumber',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Call',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fe fe-phone-call',
      className: 'connection',
      color: "#fff"
    },
    // SMS
    {
      name: 'SMS',
      field: 'cellPhoneNumber',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'SMS',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa fa-commenting-o',
      className: 'connection',
      color: "#fff"
    },

    // Email
    {
      name: 'Email',
      field: 'email',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Email',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align ti-email',
      className: 'connection',
      color: "#fff"
    },
    {
      name: 'Department',
      field: 'departmentName',
      type: 'text',
      sort: true,
      filter: false,
      maxWidth: 200,
      width: 150,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Location',
      field: 'locationName',
      type: 'text',
      sort: true,
      filter: false,
      maxWidth: 200,
      width: 120,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Shift Title',
      field: 'jobTitle',
      type: 'text',
      sort: true,
      maxWidth: 200,
      width: 120,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Shift Start Date',
      field: 'currentMultiShiftJobDateToDisplay',
      type: 'text',
      sort: true,
      maxWidth: 200,
      width: 160,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Shift End Date',
      field: 'currentMultiShiftJobEndDateToDisplay',
      type: 'text',
      sort: true,
      maxWidth: 200,
      width: 160,
      minWidth: 100,
      hide: false,
    },
    // {
    //   name: 'Job Date',
    //   field: 'jobDateToDisplay',
    //   type: 'text',
    //   sort: true,
    //   minWidth: 210,
    //   hide: false,
    // },
    // {
    //   name: 'Job End Date',
    //   field: 'jobEndDateToDisplay',
    //   type: 'text',
    //   sort: true,
    //   minWidth: 210,
    //   hide: false,
    // },
    {
      name: 'Start',
      field: 'shiftStartTime',
      type: 'text',
      sort: true,
      headerTooltip: 'Start Time',
      maxWidth: 200,
      width: 100,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'End',
      field: 'shiftEndTime',
      type: 'text',
      sort: true,
      maxWidth: 200,
      width: 100,
      minWidth: 100,
      headerTooltip: 'End Time',
      hide: false,
    },
    {
      name: 'Action',
      field: 'action',
      type: 'icon',
      filter: false,
      width: 100,
      minWidth: 125,
      hide: false,
    },
    {
      name: 'Ex In',
      field: 'inExAuthorizedStatus',
      type: 'text',
      filter: false,
      sort: false,
      width: 60,
      minWidth: 30,
      maxWidth: 150,
      hide: false,
    },
    {
      name: 'Bank',
      type: 'icon',
      filter: false,
      width: 45,
      minWidth: 35,
      maxWidth: 180,
      hide: false,
      icon: 'icon-align fa fa-bank',
      headerTooltip: 'Bank'
    },
    {
      name: 'Payrate',
      type: 'multi',
      filter: false,
      width: 45,
      minWidth: 35,
      maxWidth: 150,
      hide: false,
      icon: 'icon-align fa fa-money',
      headerTooltip: 'Payrate'
    },
    {
      name: 'Mentor',
      field: 'isMentor',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Mentor',
      maxWidth: 35,
      width:35,
      hide: false,
    },
    {
      name: 'Favorite',
      field: 'isFavorite',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Favorite',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa fa-star green-icon'
    },

    {
      name: 'Ratings',
      field: 'ratings',
      type: 'ratings',
      width: 75,
      minWidth: 85,
      hide: false,
    },

    {
      name: 'Approval',
      field: 'jobApproversList',
      type: 'icon',
      filter: false,
      sort: false,
      headerTooltip: 'Approval',
      minWidth: 90,
      hide: false,
    },
    {
      name: 'Paid',
      field: 'isPaid',
      type: 'icon',
      filter: false,
      sort: false,
      width: 45,
      minWidth: 45,
      maxWidth: 150,
      hide: false,
    },
  ];
};

export const createPageData = (page, pageSize, totalCount) => {
  if (page === 1) {
    return {
      from: page,
      to: pageSize,
      total: totalCount,
      totalPages: Math.ceil(totalCount / pageSize),
      currentPage: page,
      pageSize: pageSize,
    };
  } else {
    const pageData = paginationCalculator({
      total: totalCount,
      current: page,
      pageSize: pageSize,
    });
    return {
      from: pageData.showingStart,
      to: pageData.showingEnd,
      total: totalCount,
      totalPages: Math.ceil(totalCount / pageSize),
      currentPage: page,
      pageSize: pageSize,
    };
  }
};
